"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiRating = getMuiRating;
function getMuiRating() {
  return {
    defaultProps: {
      // @ts-ignore missing in defaultProps type
      'data-testid': 'required'
    }
  };
}